export default __webpack_public_path__ + "./assets/ChiYun__d8a45bb3918e616fe9d678b73ecc0bdd.png";